import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const aiPlatformApi = createApi({
  reducerPath: "aiPlatformApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_AI_BASE_URL || "https://ai.idealcorp.in",
    prepareHeaders: (headers, { getState }) => {
      // Get the token from auth slice
      const token = getState().auth?.token || localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["AIStats", "AIModels", "AIApplications", "AIPrompts"],
  endpoints: (builder) => ({
    getAIStats: builder.query({
      query: () => "/admin/stats",
      providesTags: ["AIStats"],
    }),
    getAIModels: builder.query({
      query: () => "/admin/models",
      providesTags: ["AIModels"],
    }),
    getApplications: builder.query({
      query: ({ page = 1, limit = 20, search = "", status = "", feature = "" } = {}) => {
        let queryParams = `?page=${page}&limit=${limit}`;
        if (search) queryParams += `&search=${encodeURIComponent(search)}`;
        if (status) queryParams += `&status=${encodeURIComponent(status)}`;
        if (feature) queryParams += `&feature=${encodeURIComponent(feature)}`;
        return `/admin/applications${queryParams}`;
      },
      providesTags: ["AIApplications"],
    }),
    getApplicationById: builder.query({
      query: (id) => `/admin/applications/${id}`,
      providesTags: (result, error, id) => [{ type: "AIApplications", id }],
    }),
    registerApplication: builder.mutation({
      query: (body) => ({
        url: "/admin/applications",
        method: "POST",
        body,
      }),
      invalidatesTags: ["AIApplications"],
    }),
    updateApplication: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/admin/applications/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["AIApplications"],
    }),
    deleteApplication: builder.mutation({
      query: (id) => ({
        url: `/admin/applications/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["AIApplications"],
    }),
    getPromptTemplates: builder.query({
      query: () => "/admin/templates",
      providesTags: ["AIPrompts"],
    }),
    upsertPromptTemplate: builder.mutation({
      query: (body) => ({
        url: "/admin/templates",
        method: "POST",
        body,
      }),
      invalidatesTags: ["AIPrompts"],
    }),
  }),
});

export const {
  useGetAIStatsQuery,
  useGetAIModelsQuery,
  useGetApplicationsQuery,
  useGetApplicationByIdQuery,
  useRegisterApplicationMutation,
  useUpdateApplicationMutation,
  useDeleteApplicationMutation,
  useGetPromptTemplatesQuery,
  useUpsertPromptTemplateMutation,
} = aiPlatformApi;
